import React from "react";

const LeafGreenBig = () => {
  return (
    <svg width="419" height="209" fill="none">
      <path fill="#43B05E" d="M201.039 2.176c73.939-11.8 217.585 56.161 217.585 56.161S271.551 186.678 210.661 205.252C139.24 223.641.974 149.228.974 149.228S150.85 11.118 201.039 2.176Z"/>
    </svg>
  )
}

export default LeafGreenBig
